// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const helpAboutSections: PaneSection[] = [
  {
    section: 'intro',
    title: 'Help and about',
    body: 'This is where you can get help, read guides, or reach the Ping team. Everything you need to find your way around is here.',
  },
  {
    section: 'support',
    title: 'Contact support',
    body: 'Write a message describing your question or issue and send it straight to the team. Add your email so we can reply to you.',
  },
  {
    section: 'guides',
    title: 'Guides',
    body: 'Browse short, step-by-step guides for the essentials like getting started, staying secure, and adding devices. Tap any guide to open it.',
  },
  {
    section: 'tours',
    title: 'Guided tours',
    body: 'Replay the walkthroughs whenever you want a refresher. Use them to revisit the app or these settings again at your own pace.',
  },
  {
    section: 'faqs',
    title: 'FAQs',
    body: 'Find quick answers to the questions people ask most. Tap a question to expand its answer.',
  },
  {
    section: 'about',
    title: 'About Ping',
    body: 'See which version of Ping you are running and open the privacy policy or terms of service. Handy when you want the details.',
  },
];
